import LinkButton from 'flarum/common/components/LinkButton';
import app from 'flarum/admin/app';
import Component from 'flarum/common/Component';
import Tooltip from 'flarum/common/components/Tooltip';
import Icon from 'flarum/common/components/Icon';
export default class ExtensionLink extends Component {
  view() {
    const {
      extension
    } = this.attrs;
    if (!extension) {
      return null;
    }
    return m(Tooltip, {
      text: extension.extra['flarum-extension'].title
    }, m(LinkButton, {
      href: app.route('extension', {
        id: extension.id
      })
    }, m("span", {
      className: "ExtensionIcon ExtensionIcon--gdpr",
      style: extension.icon
    }, !!extension.icon && m(Icon, {
      name: extension.icon.name
    }))));
  }
}
flarum.reg.add('flarum-gdpr', 'admin/components/ExtensionLink', ExtensionLink);